export const LOGO = "https://customer-assets-gfyr7b9c.emergentagent.net/job_e75a2e86-83a4-496d-9122-4957d335dd01/artifacts/wwrdflhc_ChatGPT_Image_Jul_19_2026_07_53_51_PM.png";
export const BANNER = "https://customer-assets-gfyr7b9c.emergentagent.net/job_e75a2e86-83a4-496d-9122-4957d335dd01/artifacts/edh738ah_f7ab4454-deb7-4fae-bb64-d8cb25adb2f2.png";
export const HERO_ART = "https://customer-assets-agu9un31.emergentagent.net/job_play-unlocked-2/artifacts/quh57vs3_website.webp";
export const DISCORD_URL = "https://discord.gg/injectd";

export const IMAGES = {
  cinematic_game_1: "https://images.pexels.com/photos/19964792/pexels-photo-19964792.jpeg",
  cinematic_game_2: "https://images.pexels.com/photos/23384428/pexels-photo-23384428.jpeg",
  cyberpunk_hacker: "https://images.pexels.com/photos/5952651/pexels-photo-5952651.jpeg",
  obsidian_texture: "https://images.pexels.com/photos/29353059/pexels-photo-29353059.jpeg",
  lightning: "https://images.pexels.com/photos/8308195/pexels-photo-8308195.jpeg",
};

export const productImage = (key) => {
  // Uploaded custom images are stored as absolute/relative URLs; presets are keys into IMAGES.
  if (isCustomImage(key)) return key;
  return IMAGES[key] || IMAGES.cinematic_game_1;
};

// Custom uploads render clean (no monochrome filter / logo overlay); presets keep brand treatment.
export const isCustomImage = (key) =>
  typeof key === "string" && (key.startsWith("http") || key.startsWith("/"));
